import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { useOpenEditMaskModal } from '../../../utils/routes/modals/modalsActions'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'

const AddNewButton = () => {
  const hasAddPermission = useSessionPermission('createMasks')
  const openModal = useOpenEditMaskModal()
  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={openModal} />
}

export default AddNewButton
